import script from "./ManualFloatingBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualFloatingBtn.vue?vue&type=script&setup=true&lang=js"

import "./ManualFloatingBtn.vue?vue&type=style&index=0&id=56c440f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c440f2"]])

export default __exports__